export const AltilloIcon = ({ width = 20 }) => (
  <svg width={width} height={width} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20.95 16.25L23.45 21.25H11.55L14.05 16.25H20.95ZM18.75 7.5H16.25V13.75H12.5L7.5 23.75H27.5L22.5 13.75H18.75V7.5ZM20 25C20 26.3875 18.8875 27.5 17.5 27.5C16.1125 27.5 15 26.3875 15 25H20ZM10.2625 12.6375L10.95 11.25H13.75V2.5H11.25V8.75H7.5L2.5 18.75H7.2L10.2625 12.6375Z" fill="currentColor"/>
  </svg>
);
